module.exports = __webpack_public_path__ + "img/electronic_no_zone.cf2b22af.svg";